import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import type { AxiosCacheInstance } from 'axios-cache-interceptor';
import { buildKeyGenerator, setupCache } from 'axios-cache-interceptor';

export interface AxiosWithCacheOptions {
  /**
   * Cache max-age in minutes
   */
  maxAge: number;
  /**
   * Custom cache key factory
   */
  key?: (request: AxiosRequestConfig) => string;
}

/**
 * Creates Axios instance pre-configured with cache (using axios-cache-adapter).
 * @param {AxiosWithCacheOptions} options Configuration options object
 * @returns {import('axios-cache-interceptor').AxiosCacheInstance} Pre-configured Axios instance with cache
 */
export function createAxiosWithCache({ key, maxAge }: AxiosWithCacheOptions): AxiosCacheInstance {
  return setupCache(axios, {
    generateKey: key && buildKeyGenerator(key),
    ttl: maxAge * 60 * 1000,
  });
}
